import Vue from 'vue'
import fontawesome from '@fortawesome/fontawesome'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import regular from '@fortawesome/fontawesome-pro-regular'
import light from '@fortawesome/fontawesome-pro-light'
import solid from '@fortawesome/fontawesome-pro-solid'

// import { } from '@fortawesome/fontawesome-free-regular/shakable.es'


fontawesome.library.add(
  light, solid, regular
)

Vue.component('fa', FontAwesomeIcon)
Vue.component('faLayer',FontAwesomeLayers)



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/fontawesome.js